module.exports = __webpack_public_path__ + "static/media/drake_preview.166f1b8f.png";